/**
 * TanStack Query hooks for `campaign-language-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignLanguageTargetingQueryKeys,
	type CreateCampaignLanguageTargetingBody,
	type ListCampaignLanguageTargetingResponse,
	type CampaignLanguageTargetingRow,
} from "./api";

export function useCampaignLanguageTargetingList(): UseQueryResult<ListCampaignLanguageTargetingResponse, Error> {
	return useQuery({
		queryKey: campaignLanguageTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignLanguageTargetingCreate(): UseMutationResult<CampaignLanguageTargetingRow, Error, CreateCampaignLanguageTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignLanguageTargetingQueryKeys.all });
		},
	});
}

export function useCampaignLanguageTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignLanguageTargetingQueryKeys.all });
		},
	});
}
